module.exports = __webpack_public_path__ + "assets/img/Customerwall.f1faa2de.jpg";